import {
  Button,
  Card,
  Grid,
  Icon,
  List,
  Modal,
  NavBar,
  SearchBar,
  Toast,
  WhiteSpace,
  WingBlank,
} from "antd-mobile";
//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../util/axios";
const MailDetails = styled.div`
  .body {
    // width:100%;
    // padding:10px;
  }
  .ul {
    padding: 0;
    margin: 0;
    list-style: none;
    margin-top: 10px;
    border: 1px solid #9e9999;
    border-radius: 5px;
    width: 100%;
    height: 330px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }
  .ul li {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
  .ul span {
    font-size: 16px;
    color: #333333;
  }
  .s1 {
    margin-left: 10px;
  }
  .s2 {
    margin-right: 10px;
  }
  .pdd {
    padding: 10px;
  }
`;
export default function MailDetailsList() {
  const GridStyle: React.CSSProperties = {
    padding: "5px 0",
  };
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
  }>({
    visible: false,
  });
  const [staffList1, setstaffList1] = useState<{ [key: string]: any }>({
    DicText: "",
  });
  const [staffList2, setstaffList2] = useState<{ [key: string]: any }>({
    Value: "",
  });
  const [staffList3, setstaffList3] = useState<{ [key: string]: any }>({
    Value: "",
  });
  const [staffList4, setstaffList4] = useState<{ [key: string]: any }>({
    Value: "",
  });
  const [staffList5, setstaffList5] = useState<{ [key: string]: any }>({
    Value: "",
  });
  const [staffList6, setstaffList6] = useState<{ [key: string]: any }>({
    Value: "",
  });
  const [staffList7, setstaffList7] = useState<{ [key: string]: any }>({
    Value: "",
  });
  const [staffList8, setstaffList8] = useState<{ [key: string]: any }>({
    Value: "",
  });
  const history = useHistory();
  useEffect(() => {
    let url = window.location.href; //获取请求进来的完整url
    // console.log(url)
    // let tstr = url.substring(url.indexOf('?') + 1).split('&');//先截取url的?后面的参数部分，在根据&分割成参数数组
    let tstr = url.substring(url.indexOf("=") + 1); //获取uuid
    console.log(tstr);
    instance
      .get(`/oa/common/tableGrid/tableGrid?type=base_staff&id=` + tstr)
      .then((resp) => {
        // console.log(resp)
        // console.log(resp.data.表单字段s)
        let data1 = resp.data.表单字段s.find(
          (item: any) => item.DisplayName === "所属部门"
        );
        let data2 = resp.data.表单字段s.find(
          (item: any) => item.DisplayName === "姓名"
        );
        let data3 = resp.data.表单字段s.find(
          (item: any) => item.DisplayName === "座机"
        );
        let data4 = resp.data.表单字段s.find(
          (item: any) => item.DisplayName === "报到时间"
        );
        let data5 = resp.data.表单字段s.find(
          (item: any) => item.DisplayName === "手机号码"
        );
        let data6 = resp.data.表单字段s.find(
          (item: any) => item.DisplayName === "邮箱"
        );
        let data7 = resp.data.表单字段s.find(
          (item: any) => item.DisplayName === "办公地址"
        );
        let data8 = resp.data.表单字段s.find(
          (item: any) => item.DisplayName === "房间号"
        );
        setstaffList1(data1);
        setstaffList2(data2);
        setstaffList3(data3);
        setstaffList4(data4);
        setstaffList5(data5);
        setstaffList6(data6);
        setstaffList7(data7);
        setstaffList8(data8);
      });
  }, []);

  return (
    <>
      <MailDetails>
        <div className="body">
          <NavBar
            className="orderNavBar"
            icon={
              <Icon
                type="left"
                onClick={() => {
                  history.push(`/hr/maillist`);
                }}
              />
            }
          >
            联系人详情
          </NavBar>
          <div className="pdd">
            <ul className="ul">
              <li>
                <span className="s1">部门:</span>
                <span className="s2">{staffList1.DicText}</span>
              </li>
              <li>
                <span className="s1">姓名:</span>
                <span className="s2">{staffList2.Value}</span>
              </li>
              <li>
                <span className="s1">座机:</span>
                <span className="s2">{staffList3.Value}</span>
              </li>
              <li>
                <span className="s1">报到时间:</span>
                <span className="s2">{staffList4.Value}</span>
              </li>
              <li>
                <span className="s1">手机号:</span>
                <span className="s2">{staffList5.Value}</span>
              </li>
              <li>
                <span className="s1">邮箱:</span>
                <span className="s2">{staffList6.Value}</span>
              </li>
              <li>
                <span className="s1">办公地址:</span>
                <span className="s2">{staffList7.Value}</span>
              </li>
              <li>
                <span className="s1">房间号:</span>
                <span className="s2">{staffList8.Value}</span>
              </li>
            </ul>
          </div>
        </div>
      </MailDetails>
    </>
  );
}
